import { AnyAction } from "redux";

import { myFleetActions } from "../reducer/reducer";
import { EBoxDashboardData } from "entities/cars";

export const setSelectCar = (car: EBoxDashboardData): AnyAction =>
  myFleetActions.setSelectCar(car);
